import init from "./init";
import {partner} from "../controllers/partners";

class IndexPC {

    /* STATIC */
    public static async init(): Promise<void> {
        init.pushDelayed(partner);
    }

    /* INSTANCE */
}
init.push(IndexPC);
